import isToday from 'date-fns/isToday'
import isYesterday from 'date-fns/isYesterday'

function toISO861(dateString) {
  return new Date(dateString).toISOString().split('.')[0]
}

function toISODate(date) {
  return (
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2)
  )
}

function toLocalDate(date) {
  return (
    ('0' + date.getDate()).slice(-2) +
    '/' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '/' +
    date.getFullYear()
  )
}

/**
 * Receives a Date or string(ISO) param and return long formatted date with time
 * @param {Date | String} value
 * @returns {String}
 * Hoje às 14:19 or
 * Ontem às 14:19 or
 * 09/06/2022 às 14:19
 */
function formatDateTime(dateValue) {
  if (!dateValue) {
    return ''
  }
  const date = getDate(dateValue)
  let dateString = date.toLocaleString('pt-BR', {
    dateStyle: 'short'
  })
  if (isToday(date)) {
    dateString = 'Hoje'
  } else if (isYesterday(date)) {
    dateString = 'Ontem'
  }

  const time = date.toLocaleTimeString('pt-BR', {
    timeStyle: 'short'
  })
  return `${dateString} às ${time}`
}

function formatDate(dateValue) {
  if (!dateValue) {
    return null
  }
  const dateObj = getDate(dateValue)
  const date = dateObj.toLocaleString('pt-BR', {
    dateStyle: 'short'
  })
  return `${date}`
}

function getDate(dateValue) {
  if (dateValue instanceof Date) return dateValue
  dateValue = dateValue + 'Z'
  return new Date(dateValue)
}

function timeDifference(date) {
  if (!date) return 'sem data'

  const msPerSecond = 1000
  const msPerMinute = msPerSecond * 60
  const msPerHour = msPerMinute * 60
  const msPerDay = msPerHour * 24
  const msPerMonth = msPerDay * 30
  const msPerYear = msPerDay * 365

  function getDateInMs(date) {
    return date instanceof Date ? date.getTime() : Number(date) * msPerSecond
  }

  function getSuffix(quantity) {
    return quantity > 1 ? 's' : ''
  }

  const previous = getDateInMs(date)
  const elapsed = new Date().getTime() - previous

  if (elapsed < msPerMinute) {
    const seconds = Math.round(elapsed / msPerSecond)
    return `${seconds} seg${getSuffix(seconds)}`
  } else if (elapsed < msPerHour) {
    const minutes = Math.round(elapsed / msPerMinute)
    return `${minutes} min${getSuffix(minutes)}`
  } else if (elapsed < msPerDay) {
    const hours = Math.round(elapsed / msPerHour)
    return `${hours} h`
  } else if (elapsed < msPerMonth) {
    const days = Math.round(elapsed / msPerDay)
    return `${days} dia${getSuffix(days)}`
  } else if (elapsed < msPerYear) {
    const months = Math.round(elapsed / msPerMonth)
    return `${months} ${months > 1 ? 'meses' : 'mês'}`
  }
  const years = Math.round(elapsed / msPerYear)
  return `${years} ano${getSuffix(years)}`
}

/**
 * Receives a Date or string(ISO) param and return formatted date with day and month and hour
 * @param {Date | String} value
 * @returns {String}
 * 12 de abr · 18:16 or
 * 03 de mar · 17:37 or
 * 09 de maio · 08:23
 */
const toDayAndMonthAndHour = date => {
  if (!date) return null

  const monthLabels = {
    0: 'jan',
    1: 'fev',
    2: 'mar',
    3: 'abr',
    4: 'maio',
    5: 'jun',
    6: 'jul',
    7: 'ago',
    8: 'set',
    9: 'out',
    10: 'nov',
    11: 'dez'
  }
  const day = new Date(date).getDate()
  const month = monthLabels[new Date(date).getMonth()]
  const time = getDate(date).toLocaleTimeString('pt-BR', {
    timeStyle: 'short'
  })

  return `${day} de ${month} · ${time}`
}

export {
  toISO861,
  toISODate,
  toLocalDate,
  toDayAndMonthAndHour,
  formatDateTime,
  formatDate,
  timeDifference
}
